<template>
  <!--  begin feature section  -->
  <section class="bg-white feature">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-laptop"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Complete Solutions</h3>
              <p class="feature-description">
                From development to support: systems, websites, APIs and custom
                automations to help your business grow.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-eye"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">Modern Design</h3>
              <p class="feature-description">
                Beautiful, responsive and functional interfaces that enhance
                your brand identity and delight users.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-thumbs-o-up"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">User Experience</h3>
              <p class="feature-description">
                Intuitive navigation and usability designed to generate
                engagement and real results for your project.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>

        <div class="col-md-3">
          <div class="feature-content text-center">
            <div class="feature-icon-box">
              <div class="feature-icon center-block">
                <i class="fa fa-star"></i>
              </div>
            </div>
            <!--  end of /.feature-icon-box  -->
            <div class="feature-info">
              <h3 class="feature-heading">High Satisfaction</h3>
              <p class="feature-description">
                Close support, agile deliveries and consistent results that
                generate trust and loyalty from our clients.
              </p>
              <!--   end of /.feature-description  -->
            </div>
            <!--   end of /.feature-info  -->
          </div>
          <!--  end of /.feature-content  -->
        </div>
      </div>
    </div>
    <!-- end of /.container -->
  </section>
  <!--   end of feature section  -->
</template>

<script>
export default {
  name: "FeatureSection",
};
</script>
